import { Component, OnInit, inject } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-reset-password-edit',
    imports: [FormsModule],
    templateUrl: './reset-password-edit.component.html'
})
export class ResetPasswordEditComponent implements OnInit {
  private http = inject(HttpClient);
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private toastr = inject(ToastrService);

  data = { password: '' };
  confirmPassword = '';
  private token = '';

  async ngOnInit(): Promise<void> {
    this.token = this.route.snapshot.params['token'] ?? '';
    if (!this.token) {
      await this.router.navigate(['/reset-password']);
      return;
    }

    try {
      const res = await firstValueFrom(
        this.http.get<any>(`${environment.apiBaseUrl}/member/reset/${encodeURIComponent(this.token)}`, {
          headers: { '__skipAuthInterceptor': 'true' },
        })
      );
      if (!res?.result) {
        this.toastr.warning('有効なURLではありません。再度手続きを行ってください。', '', { timeOut: 30000 });
        await this.router.navigate(['/reset-password']);
      }
    } catch {
      this.toastr.warning('有効なURLではありません。再度手続きを行ってください。', '', { timeOut: 30000 });
      await this.router.navigate(['/reset-password']);
    }
  }

  get passwordValid(): boolean {
    return this.data.password.length >= 8 && this.data.password.length <= 16;
  }

  get passwordsMatch(): boolean {
    return this.data.password === this.confirmPassword;
  }

  async resetNow(): Promise<void> {
    try {
      const res = await firstValueFrom(
        this.http.post<any>(`${environment.apiBaseUrl}/member/reset`, {
          token: this.token,
          password: this.data.password,
        }, {
          headers: { '__skipAuthInterceptor': 'true' },
        })
      );
      if (res?.result) {
        this.toastr.success('パスワードを更新しました。', '', { timeOut: 30000 });
      } else {
        this.toastr.warning('パスワードの更新に失敗しました。再度手続きを行ってください。', '', { timeOut: 30000 });
      }
    } catch {
      this.toastr.warning('パスワードの更新に失敗しました。再度手続きを行ってください。', '', { timeOut: 30000 });
    }
    await this.router.navigate(['/login']);
  }
}
